// src/components/DashboardAuth.js
import React, { useState } from 'react';
import TrialManagementDashboard from './TrialManagementDashboard';
import './DashboardAuth.css';

// Simple authentication component to protect the dashboard
// In a production environment, you'd want to use a more secure authentication method
function DashboardAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  
  // This should be replaced with a secure authentication method
  // For demo purposes, we're using a simple password check
  const ADMIN_PASSWORD = 'blue-comet-admin'; // Change this to your desired password
  
  const handleLogin = (e) => {
    e.preventDefault();
    
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Invalid password');
    }
  };
  
  // If authenticated, show the dashboard
  if (isAuthenticated) {
    return <TrialManagementDashboard />;
  }
  
  // Otherwise, show the login screen
  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h2>Admin Dashboard</h2>
          <p>Enter your password to access the trial management dashboard</p>
        </div>
        
        {error && <div className="auth-error">{error}</div>}
        
        <form className="auth-form" onSubmit={handleLogin}>
          <div className="form-field">
            <label htmlFor="password">Admin Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
            />
          </div>
          
          <button type="submit" className="login-button">
            Access Dashboard
          </button>
        </form>
      </div>
    </div>
  );
}

export default DashboardAuth;